
import {
    Zap, ShieldCheck, Globe,
    ArrowRight,
    Lightbulb, Droplets, Car, PhoneCall, Wifi, Flame, Building2, Landmark, HeartPulse, ShieldIcon
} from 'lucide-react';
import Bill_Payment from "../../Assets/bbps_service.webp"
import CtaSection from '../CtaSection/CtaSection';
import { Link } from 'react-router-dom';



const mainServices = [
    { name: "FasTag", icon: Car, color: "#3B82F6" },
    { name: "Postpaid Bill", icon: PhoneCall, color: "#6366F1" },
    { name: "Electricity", icon: Lightbulb, color: "#F59E0B" },
    { name: "Broadband", icon: Wifi, color: "#A855F7" },
    { name: "Water Bill", icon: Droplets, color: "#06B6D4" },
    { name: "Pipe Gas", icon: Flame, color: "#F97316" },
    { name: "Municiple Tax", icon: Building2, color: "#10B981" },
    { name: "Loan Repayment", icon: Landmark, color: "#3B82F6" },
    { name: "Life Insurance", icon: ShieldCheck, color: "#F43F5E" },
    { name: "General Insurance", icon: ShieldIcon, color: "#64748B" },
    { name: "Health Insurance", icon: HeartPulse, color: "#EC4899" },
];


const BillPayments = () => {




    return (
        <div className="min-h-screen bg-white">

            <div className="relative bg-[#0F172A] pt-20 pb-32 lg:pt-32 lg:pb-48 overflow-hidden">


                <div className="max-w-7xl mx-auto px-6 relative z-10">
                    <div className="grid lg:grid-cols-2 gap-12 items-center">
                        <div className="text-center lg:text-left">
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-bold mb-6">
                                <Zap size={16} />
                                <span>Bumppy Bill Payment Services</span>
                            </div>
                            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
                                Empower Your Retail Shop with <span className="text-blue-500">BBPS</span>
                            </h1>
                            <p className="text-slate-400 text-lg md:text-xl mb-8 leading-relaxed max-w-2xl">
                                Convert your shop into a digital payment hub. Offer 20+ bill payment services to your customers and earn high commissions instantly.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                                <a href='https://dashboard.bumppy.com/'>
                                    <button className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold shadow-lg shadow-blue-900/20 flex items-center justify-center gap-2 transition-all hover:scale-105">
                                        Join Bumppy <ArrowRight size={20} />
                                    </button>
                                </a>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="  rotate-3 hover:rotate-0 transition-transform duration-500">
                                <img src={Bill_Payment} alt='bill payment' className='rounded-lg' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="max-w-7xl mx-auto px-6 -mt-16 lg:-mt-24 relative z-20">
                <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-200/60 p-8 lg:p-12 border border-slate-100">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-slate-900 mb-4">Included Services in BBPS</h2>
                        <p className="text-slate-500">All-in-one centralized platform for recurring and one-time payments</p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
                        {mainServices.map((service, index) => (
                            <div key={index} className="group flex flex-col items-center p-6 rounded-2xl hover:bg-slate-50 transition-all border border-transparent hover:border-slate-100">
                                <div
                                    style={{ "--clr": service.color }}
                                    className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4
             bg-[color-mix(in_srgb,var(--clr)_15%,transparent)]
             text-[var(--clr)]
             group-hover:bg-[var(--clr)]
             group-hover:text-white
             group-hover:scale-110
             transition-all"
                                >
                                    <service.icon size={28} />
                                </div>

                                <span className="text-sm font-bold text-slate-700 text-center">{service.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-6 pt-16 lg:pt-20">
                <div className="mb-16">
                    <h2 className="text-3xl text-start md:text-4xl  font-extrabold text-slate-900 mb-6">
                        Bumppy Bill <span className="text-blue-600">Payment Services (BBPS)</span>
                    </h2>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">Bumppy Bill Payment Services For Retailers Are Profitable And Easy to use. Just keeping track of all the bills that need to be paid and then going to pay them is, at best, a major time-consuming task for the average person. When people had to wait in lengthy lines and deal with uncooperative staff members just to pay the bills for their neccessery, this problem was particularly intense at one point. With the development of tools like the BBPS portal and numerous bill Payment apps, which are centralised, integrated platforms where customers can simply pay all of their bills via a variety of methods and point-of-sale methods, this is no longer the case.</p>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">As a retailer, you will be Register with the Bumppy BBPS portal as an Agent through Bumppy Payments and be authorized to do bill Payments for your customers keep certain rules and regulations in mind which are easy to follow and quite convenient.Bill pay app allows you to do onetime and recurring bill Payments for a wide variety of services.</p>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">Being a service provider for the underprivileged community in your area, for whom making these Payments conveniently is a huge benefit, gives you a sense of fulfilment.</p>
                </div>


            </div>


            <div className="max-w-7xl mx-auto px-6 pt-5 md:pt-10 pb-16 lg:pb-20">
                <div className="mb-16">
                    <h2 className="text-3xl text-start md:text-4xl  font-extrabold text-slate-900 mb-6">
                        Why Choose <span className="text-blue-600">Bumppy Payments</span>
                    </h2>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">A trustworthy, secure, and safe gateway that enables you to complete a range of Bharat Bill Pay transactions. These transactions will be recorded, and you will be compensated with commissions for each one.</p>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">The choice to make numerous various types of Payments, including those for municipal taxes, utility bills, and more. All of this creates numerous income stream</p>
                    <p className="text-slate-500  text-lg mb-4 mx-auto">Being a service provider for the underprivileged community in your area, for whom making these Payments conveniently is a huge benefit, gives you a sense of fulfilment.</p>
                </div>


            </div>

            {/* Hindi Highlight Section */}
            <div className="bg-blue-600 py-16">
                <div className="max-w-4xl mx-auto px-6 text-center">
                    <div className="inline-flex p-3 bg-white/10 rounded-2xl mb-6">
                        <Globe className="text-white" size={32} />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-white leading-snug">
                        रिटेल दुकान विक्रेता के लिए Bumppy Payments द्वारा उपलब्ध कराई गई यह बीबीपीएस बिल पेमेंट सेवाएं बेहद लाभदायक हैं।
                    </h2>
                    <p className="mt-4 text-blue-100">आज ही हमसे जुड़ें और अपनी आमदनी बढ़ाएं।</p>
                </div>
            </div>

            {/* Cross-Sell Services */}
            <div className="max-w-7xl mx-auto px-6 py-20">
                <div className="flex flex-col md:flex-row items-center justify-between gap-8 p-8 lg:p-12 rounded-[2rem] bg-slate-900 text-white">
                    <div>
                        <h2 className="text-3xl font-bold mb-2">Explore Analytics</h2>
                        <p className="text-slate-400">Track every transaction and commission with our advanced dashboard.</p>
                    </div>
                    <div className="flex gap-4">
                        <Link to="/product/bill-payment" className="px-6 py-3 bg-white/10 hover:bg-white/20 rounded-xl font-bold transition-all">BBPS Portal</Link>
                        <Link to="/product/analytics-dashboard" className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-xl font-bold transition-all">Analytics Dashboard</Link>
                    </div>
                </div>
            </div>

            <CtaSection />

            <style jsx>{`
        .bg-blue-50 { background-color: #eff6ff; } .text-blue-600 { color: #2563eb; }
        .bg-indigo-50 { background-color: #eef2ff; } .text-indigo-600 { color: #4f46e5; }
        .bg-amber-50 { background-color: #fffbeb; } .text-amber-600 { color: #d97706; }
        .bg-purple-50 { background-color: #faf5ff; } .text-purple-600 { color: #9333ea; }
        .bg-cyan-50 { background-color: #ecfeff; } .text-cyan-600 { color: #0891b2; }
        .bg-orange-50 { background-color: #fff7ed; } .text-orange-600 { color: #ea580c; }
        .bg-emerald-50 { background-color: #ecfdf5; } .text-emerald-600 { color: #059669; }
        .bg-rose-50 { background-color: #fff1f2; } .text-rose-600 { color: #e11d48; }
        .bg-slate-50 { background-color: #f8fafc; } .text-slate-600 { color: #475569; }
        .bg-pink-50 { background-color: #fdf2f8; } .text-pink-600 { color: #db2777; }
      `}</style>
        </div>
    );
};

export default BillPayments;